import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import SelectField from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { httpClient } from '../restClient';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const styles = theme => ({
  container: {
    marginTop: "20px",
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: "10px",
    marginRight: "10px",
    width: 150,
  },
  selectField: {
    marginLeft: "10px",
    marginRight: "10px",
    width: 150,
  },
  dateField: {
    marginLeft: "10px",
    marginRight: "10px",
    width: 200,
  },
  sendButton:{
    height:"30px",
    width:"150px"
  },
  resultItem:{
    marginTop:"5px"
  },
  resultSection:{
    marginTop:"15px",
    paddingLeft:"10px"
  },
  progressSpinner: {
    color: green[700],
    position: 'absolute'
  },
  createdAtLabel: {
    position: 'absolute',
    top: "-16px",
    left: "9px",
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.54)",
    fontFamily: "Tajawal"
  },
  table:{

  },
  totalGames:{

  }
});

class GamesSummary extends Component {
  state = {
    from_date: "2017-01-01",
    business_type: 0,
    to_date: "2022-01-01", //(new Date).toISOString().split("T")[0],
    progress: false,
    country: null,
    data: null
  };

  componentDidMount() {}

  getSummaryCounts = () => {
    var self=this;
    this.setState({data: null, progress: true});
    console.log("Getting data now in gamessummary")
    var uri = "/api/games_summary?country=" + this.state.country + "&business_type=" + this.state.business_type + "&from_date=" + this.state.from_date + "&to_date=" + this.state.to_date;
    httpClient(uri, {}).then( (response) => {
        console.dir(response.json);
        response.json.progress = false;
        this.setState({data: response.json, progress: false});
      }
    )
  }


  handleChange = name => event => {
    let value = event.target.value;
    this.setState({ [name]: value });
  }

  render() {
    //const classes = useStyles();
    const {} = this.state;
    const { classes, width } = this.props;
    const rows=[{label:"Offline", key:"offlines", sprint: "17_12"},
                {label:"Levels", key: "levels", sprint: "17_04"},
                {label:"Improve answer", key: "continues", sprint: "17_08"},
                {label:"Player feedback", key: "feedbacks", sprint: "19_04"},
                {label:"Badges", key: "badges", sprint: "17_06"}]


    return (
      <div>
        <div>
          {"Games KPIs"}
          <form className={classes.container} noValidate>
            <TextField
              id="name"
              label="Country"
              type="text"
              defaultValue=""
              onChange={this.handleChange("country")}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }} />
            <SelectField
              value={this.state.business_type}
              onChange={this.handleChange("business_type")}
              className={classes.selectField}
              >
                <MenuItem value={0}>All</MenuItem>
                <MenuItem value={1}>Paying</MenuItem>
                <MenuItem value={2}>Pilot</MenuItem>
                <MenuItem value={3}>Demo/Test</MenuItem>
                <MenuItem value={4}>Edustore</MenuItem>
                <MenuItem value={5}>Webshop personal</MenuItem>
                <MenuItem value={6}>Trial personal</MenuItem>
                <MenuItem value={7}>Freemium personal</MenuItem>
                <MenuItem value={9}>Sponsored game user</MenuItem>
                <MenuItem value={10}>New Player License model</MenuItem>
            </SelectField>
            <div style={{position: 'relative'}}>
            <div className={classes.createdAtLabel}>Created_at</div>
            <TextField
              id="from_date"
              label="From date"
              type="date"
              defaultValue={this.state.from_date}
              onChange={this.handleChange("from_date")}
              className={classes.dateField}
              InputLabelProps={{
                shrink: true,
              }} />
            <TextField
              id="to_date"
              label="Until/Trough date"
              type="date"
              defaultValue={this.state.to_date}
              onChange={this.handleChange("to_date")}
              className={classes.dateField}
              InputLabelProps={{
                shrink: true,
              }} />
            </div>
            <Button
              onClick={this.getSummaryCounts}
              size="small"
              variant="raised"
              color="secondary"
              className={classes.sendButton}
              >
              {"Send"}
            </Button>
          </form>
        </div>
        <div className={classes.resultSection}>
          {this.state.progress && (
            <CircularProgress size={100} className={classes.progressSpinner} />
          )}
          {this.state.data &&  <React.Fragment>
            <div className={classes.totalGames}>Total games: {this.state.data.total_games}</div>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell style={{minWidth: "170px"}}>Attribute</TableCell>
                  <TableCell>Implemented</TableCell>
                  <TableCell>Count</TableCell>
                  <TableCell>Percentage</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <TableRow key={row.key}>
                    <TableCell component="th" scope="row">
                      {row.label}
                    </TableCell>
                    <TableCell>{row.sprint}</TableCell>
                    <TableCell>{this.state.data[row.key]}</TableCell>
                    <TableCell>{(this.state.data[row.key]/this.state.data.total_games*100).toFixed(2) + "%"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </React.Fragment>
          }
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(GamesSummary);


// WEBPACK FOOTER //
// ./src/dashboard/GamesSummary.js